import Vue from 'vue';
import ApiService from '../lib/api';

const state = {
    timezones: [],
    byOffset: {},
    byName: {},
};

const mutations = {
    setTimezones(store, payload) {
        Vue.set(store, 'timezones', payload);

        for (const i in store.timezones) {
            const tz = store.timezones[i];
            store.byOffset[tz.timezone_offset] = tz;
            store.byName[tz.name] = tz;
        }
    },
};

const actions = {
    load({commit, getters}) {
        return new Promise(resolve => {
            if (getters.getTimezones.length > 0) {
                return resolve(getters.getTimezones);
            }

           ApiService.get('/timezones').then(resp => {
               commit('setTimezones', resp.data);
               resolve(resp.data);
           });
        });
    }
};

const getters = {
    getTimezones: (state) => {
        return state.timezones;
    },
    getByOffset: (state) => (offset) => state.byOffset[offset],
    getByName: (state) => (name) => state.byName[name],
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};
